import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ModelIcon, CloseIcon, EditIcon, UploadIcon, EvaluateIcon } from "../../Icons/Icons";
import { NestedMenuItem } from "mui-nested-menu";
import { useAppDispatch, useAppSelector } from "../../store";
import { getUploadedLocatorData } from "../../store/selectors/LocatorSelectors";
import { updateUploadedLocatorData } from "../../store/reducers/LocatorsReducers";
import { setIsUploadStarted } from "../../store/reducers/DatasetReducer";
import { LocatorImageType } from "../../types/LocatorTypes";
import userHook from '../../hooks/userHook';
import clientHomepage from './ClientHomepage';

const homeActions = [
  { name: "Upload", icon: UploadIcon, submenu: true },
  { name: "Manage Datasets", icon: EditIcon, url: "/datasets" },
  { name: "Use prediction models", icon: ModelIcon, url: "/models" },
  { name: "Evaluate predictions", icon: EvaluateIcon, url: "/evaluate" },
];

const Homepage = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const currentLocatorData = useAppSelector(getUploadedLocatorData);
  const { isAdmin, loading } = userHook();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>, item: any) => {
    item?.submenu ? setAnchorEl(event.currentTarget) : navigate(item.url);
  };

  const handleClose = () => {
    setAnchorEl(null);
    dispatch(setIsUploadStarted(true));
  };

  const onSelectImageType = (imagetype: LocatorImageType) =>
    dispatch(updateUploadedLocatorData({ ...currentLocatorData, imagetype }));

  const onLocatorPhotoSelect = () => {
    onSelectImageType(LocatorImageType.PHOTO);
    handleClose();
    navigate("/dataset/locators/1");
  };

  const onLocatorRenderSelect = () => {
    onSelectImageType(LocatorImageType.RENDER);
    handleClose();
    navigate("/dataset/locators/1");
  };

  const onScrewPhotoSelect = () => {
    handleClose();
    navigate("/dataset/screws/1");
  };

  const itemMenu = (
    <Menu
      classes={{ list: "main-list" }}
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <MenuItem onClick={handleClose}>
        <CloseIcon />
      </MenuItem>
      <NestedMenuItem
        label="Locator"
        className="active"
        parentMenuOpen={open}
        MenuProps={{
          classes: {
            root: "submenu-list",
            paper: "submenu",
          },
        }}
      >
        <MenuItem onClick={onLocatorPhotoSelect}>Add a photo</MenuItem>
        <MenuItem onClick={onLocatorRenderSelect}>Add a render</MenuItem>
      </NestedMenuItem>
      <NestedMenuItem
        label="Screw"
        className="active"
        parentMenuOpen={open}
        MenuProps={{
          classes: {
            root: "submenu-list",
            paper: "submenu",
          },
        }}
      >
        <MenuItem onClick={onScrewPhotoSelect}>Add a photo</MenuItem>
      </NestedMenuItem>
    </Menu>
  );

  const actionItem = (item: any) => {
    const { name, icon } = item;
    const Icon = icon;

    return (
      <Button
        className="action-item"
        key={name}
        onClick={(event) => handleClick(event, item)}
      >
        <Icon />
        <h4>{name}</h4>
      </Button>
    );
  };

  const actionWrapper = (
    <div className="action-wrapper">
      {homeActions.map((action) => actionItem(action))}
      {itemMenu}
    </div>
  );

  if (loading) {
    return <div>Loading...</div>;
  }

  if (isAdmin) {
    return actionWrapper;
  } else {
    return clientHomepage;
  }
};

export default Homepage;
